var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7506 1.4082H1.24752C0.864711 1.4082 0.625648 1.82539 0.817836 2.1582L4.45221 8.33633V12.0957C4.45221 12.3723 4.67409 12.5957 4.94909 12.5957H9.04909C9.32409 12.5957 9.54596 12.3723 9.54596 12.0957V8.33633L13.1819 2.1582C13.3725 1.82539 13.1335 1.4082 12.7506 1.4082ZM8.42721 11.4707H5.57096V9.0332H8.42877V11.4707H8.42721ZM8.57721 7.77383L8.42877 8.0332H5.5694L5.42096 7.77383L2.32252 2.5332H11.6756L8.57721 7.77383Z",
    fill: "#6F6F76"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7506 1.4082H1.24752C0.864711 1.4082 0.625648 1.82539 0.817836 2.1582L4.45221 8.33633V12.0957C4.45221 12.3723 4.67409 12.5957 4.94909 12.5957H9.04909C9.32409 12.5957 9.54596 12.3723 9.54596 12.0957V8.33633L13.1819 2.1582C13.3725 1.82539 13.1335 1.4082 12.7506 1.4082ZM8.42721 11.4707H5.57096V9.0332H8.42877V11.4707H8.42721ZM8.57721 7.77383L8.42877 8.0332H5.5694L5.42096 7.77383L2.32252 2.5332H11.6756L8.57721 7.77383Z",
    fill: "black",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filterIcon.791c2c2c7910272f89487d8a0c0ee5c5.svg";
export { ForwardRef as ReactComponent };